// extracted by mini-css-extract-plugin
export default {"infoIcon":"LTInfo_infoIcon__bMhTg","modal":"LTInfo_modal__yi71X","content":"LTInfo_content__Oi8Ep","headerCell":"LTInfo_headerCell__1qDPz","methodCell":"LTInfo_methodCell__CKygN"};